module.exports = __webpack_public_path__ + "static/img/login-img.5e51ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login-img.png
// module id = 8h0x
// module chunks = 1